Vue.asyncComponent('ak-data-table-body', {
    data() {
        return {
            showModal: false,
            contextualWidgets: {
                list: []
            },
            objectIds: [],
            isOverflowing: false,
            snackbarMessage: '',
            autoSelection: false,
            dragId: null,
            showDragContext: false,
            dragContextPosition: {
                x: 0,
                y: 0
            },
            dragContextTimeout: null,
            dragging: null,
            activeRowId: '',
            activeSelectAll: false,
            isMobileView: false,
            viewMode: null,
            columnListVisible: false
        }
    },
    props: {
        columns: {
            type: Array,
            required: true,
            default: () => []
        },
        definition: {
            type: String,
            required: true
        },
        bundle: {
            type: String,
            required: true
        },
        dataObjects: {
            type: Array,
            required: true,
            default: () => {}
        },
        // viewMode: {
        //     type: String,
        //     required: false,
        //     default: 'default'
        // },
        selectables: {
            type: Object,
            required: true,
            default: () => {}
        },
        selection: {
            type: Object,
            required: true,
            default: () => {}
        },
        isUpdating: {
            type: Boolean,
            required: false,
            default: false
        },
        sortingEnabled: {
            type: Boolean,
            required: false,
			default: false
		},
		pageJumper: {
			type: Object,
			required: false,
			default: () => {}
		},
        widgetCallbackUri: {
            type: String,
            required: true
        },
        maxTableHeight: {
            type: Number,
            required: false
        },
        noResultString: {
            type: String,
            required: false,
            default() {
                return this.$t('Geen resultaten gevonden');
            }
        },
        noResultWidget: {
            type: Object,
        },
        initialized: {
            type: Boolean,
            required: false,
            default: false
        },
        showError: {
            type: Boolean,
            required: false,
            default: false
        },
        paramsForCallback: {
            type: Object,
            required: false,
            default: () => {}
        },
        forceMobile: {
            type: Boolean,
        },
        disableMobileView: {
            type: Boolean,
            required: false,
            default: false
        },
        headerContextualWidget: {
            type: Object,
            required: false,
            default: null
        },
        headerContextualWidgetContextType: {
            type: String,
            required: false,
            default: null
        }
    },
    computed: {
        mutableDataObjects: {
            get() {
                return this.dataObjects;
            },
            set(e) {
                console.log(e);
                this.$emit('changeList', e);
            }
        },
        widgetsInRow() {
            return this.dataObjects.some((row) => {
                return row.hasOwnProperty('widgets');
            });
        },
        totalColumnCount() {
            let columnCount = this.columns.length
        
            if(this.sortingEnabled) {
                columnCount++;
            }

            if(this.selectables.canSelectAll || this.selectables.canSelectOneByOne) {
                columnCount++;
            }
            
            if(this.widgetsInRow) {
                columnCount++;
            }
            
            return columnCount;
        },
        dragContextOptions() {
			const index = this.dataObjects.findIndex(x => x.id === this.dragId);

			if (this.dataObjects.length === 1 || index === -1) return {};
			let options = null;

            switch (index) {
                case 0 && this.pageJumper.activePage === 1: 
                    options = [
                        { title: 'To bottom', value: 'bottom' }
					];
					break;
                case this.dataObjects.length - 1: case this.pageJumper.activePage === this.pageJumper.numberOfPages:
                    options = [
                        { title: 'To top', value: 'top' }
					];
					break;
                default:
                    options = [
                        { title: 'To top', value: 'top' },
                        { title: 'To bottom', value: 'bottom' }
					];
					break;
			}

			if (!this.$getSetting('config.infiniteScroll') && this.pageJumper.activePage !== 1 && index === 0) {
				options.splice(1, 0, { title: 'Up 1', value: 'up'} );
			}
			if (index === this.pageJumper.countPerPage - 1 && this.pageJumper.activePage !== this.pageJumper.numberOfPages) {
				options.splice(1, 0, { title: 'Down 1', value: 'down' });
			}
			
			return options;
        },
        selectModalContent() {
            let string = this.$t(`Wil je alle items selecteren of enkel de ingeladen items?`);
            if( this.pageJumper.totalCount > this.selectables.maximum) {
                string += (this.selectables.maximum ? this.$t(`Je mag er maximum @max) selecteren.`, {'@max': this.selectables.maximum}) : '')
            }

            return string;
        }
    },
    methods: {
        showSelectAllModal() {
            if (this.selection.allSelected) {
                this.selectAll();
            }
            else if (this.autoSelection) {
                this.selection.idsSelected = [];
                this.autoSelection = false;
            }
            else {
                this.showModal = true;
            }
        },
        selectAll() {

            if(this.objectIds.length > this.selectables.maximum) {
                return this.selectMaximum();
            }

            this.selection.allSelected = !this.selection.allSelected;
            if (this.selection.allSelected && !this.autoSelection) this.selection.idsSelected = this.objectIds;
            else this.selection.idsSelected = [];
            this.closeModal();
        },
        closeModal() {
            this.showModal = false;

            if(!this.selection.allSelected && !this.autoSelection) {
                this.activeSelectAll = false;
            }
        },
        selectMaximum() {
            this.autoSelection = true;
            this.selection.idsSelected = this.objectIds.slice(0, this.selectables.maximum);
            this.closeModal();
        },
        isRowSortedBy(key) {
            return this.columns.find(x => x.id === key).isSortedBy;
        },
        findColumnTitle(key) {
            return this.columns.find(x => x.id === key).title;
        },
        applyColumnFormatting(key, value) {
            const formatting = this.columns.find(x => x.id === key).formatting;

            // if there is no formatting set in for this value just return the value
            if(typeof formatting == 'undefined') {
                return value;
            }
            
            // else we apply the formatting
            return this.$applyFormatting(value, formatting);
        },
        sortColumn(column) {
            if (this.isUpdating) return;
            this.$emit('sortColumn', column);
        },
        setActiveRow(id) {
			this.activeRowId = id;
        },
        handleEdit(data) {
            this.$emit('edit', data);
        },
        handleDeleteSelectedIds() {
            this.selection.idsSelected = [];
        },
        handleDelete(data) {
            const indexToDelete = this.selection.idsSelected.findIndex(id => id === data.objectId);

            if(indexToDelete !== -1) {
                this.selection.idsSelected.splice(indexToDelete, 1);
            }

			if (this.isUpdating) return;
            this.$emit('delete', data);
        },
        dragStart(e) {
            this.dragId = e.item.id;
            this.showDragContext = false;
            this.dragging = e.item.id;
            clearTimeout(this.dragContextTimeout);
        },
        dragEnd() {
			this.$emit('sort', { id: this.dragId, instruction: 'drag' });
            this.dragId = '';
			this.dragging = null;
			
        },
        draghandleClickContext(id, e) {
            this.dragContextTimeout = setTimeout(() => {
                this.dragId = id;
                this.dragContextPosition =  {
                    x: e.clientX,
                    y: e.clientY
                };
                this.showDragContext = true;
            }, 100);
        },
        changePosition(to) {
            this.showDragContext = false;
			
			this.$emit('sort', { id: this.dragId, instruction: to });
		},
        getTable() {
            try {
                return this.$refs.table;
            } catch (error) {
                return undefined;
            }
            
        },
        /**
         * Get the contextual title for a specififc row
         * @param rowId
         * @returns {null|*}
         */
        getContextualTitle(rowId) {
            if ( ! rowId) {
                return null;
            }

            return this.dataObjects.find(dataObject => dataObject.id === rowId).title;
        },
        /**
         * data table needs to be refreshed
         */
        triggerRefresh() {
            this.toggleColumnList(false);
            this.$emit('refresh');
        },
        /**
         * Check if we need to switch to mobile view
         */
        screenResize() {
            if (this.disableMobileView) {
                return false;
            }

            this.isMobileView = window.innerWidth < 768;

            if (this.forceMobile) {
                this.isMobileView = true;
            }
        },
        /**
         * Set the selection for this row
         * @param rowId
         */
        selectRow(rowId) {
            if(this.selectables.maximum == 1) {
                this.idSelected = rowId
            } else {
                this.selection.idsSelected.push(rowId);
            }
        },
        /**
         * Remove the selection for this row
         * @param rowId
         */
        deselectRow(rowId) {
            if(this.selectables.maximum == 1) {
                this.idSelected = null;
            } else {
                const index = this.selection.idsSelected.indexOf(rowId);
                this.selection.idsSelected.splice(index, 1);
            }
        },
        /**
         * A widget is changed
         * @param event
         */
        widgetChanged(event) {
            if (event.objectId) {
                this.$emit('widgetChanged', event.objectId);
            } else {
                console.error('No objectId was given for the widgetChanged callback');
            }
        },
        /**
         * Get the width of a specific type of column
         * @param columnId
         * @returns {*}
         */
        getColumnWidth(columnId) {
            return this.columns.find(column => column.id === columnId).width;
        },
        /**
         * Set view mode
         * We can toggle to a compact view mode or a default view mode
         * @param data
         */
        setViewMode(data) {
            this.viewMode = data.viewMode;
            this.$root.$el.dispatchEvent(new CustomEvent('view-mode-changed', {
                detail: {
                    viewMode: this.viewMode
                }
            }));
        },
        /**
         * Toggle Column List
         * @param flag
         */
        toggleColumnList(flag = true) {
            this.columnListVisible = flag;
        },
        /**
         * Sort item up in the sorting
         * @param currentRow
         */
        sortItemUp(currentRow) {
            this.$emit('sort', { id: currentRow.id, instruction: 'up' });
        },
        /**
         * Sort item down in the sorting
         * @param currentRow
         */
        sortItemDown(currentRow) {
            this.$emit('sort', { id: currentRow.id, instruction: 'down' });
        },
        checkOverflow() {
            this.isOverflowing = this.$el.clientWidth < this.$refs.table.clientWidth;
        },
        handleSelectionRefresh() {
            this.clearSelection();
            this.triggerRefresh();
        },
        clearSelection() {
            this.selection.idsSelected = [];
            this.selection.allSelected = false;
            this.activeSelectAll = false;
            this.autoSelection = false;
        }
    },
    watch: {
        dataObjects(e) {
            this.objectIds = this.dataObjects.filter(x => x.canSelect === true).map(x => x.id);
            if (this.selection.allSelected) this.selection.idsSelected = this.objectIds;
        },
        'selection.idsSelected': {
            handler(e) {
                if (!e.length) {
                    // when we clear the selection from a parent component and we have no items selected
                    // we clear the autoSelection prop
                    this.autoSelection = false;
                    this.activeSelectAll = this.selection.allSelected;
                }

                if (e.length === this.selectables.maximum + 1) {
                    this.$nextTick(()=> {
                        e.pop();
                    });
                    this.snackbarMessage = this.$t(`Maximaal @max tegelijk selecteerbaar.`, {'@max': this.selectables.maximum});
                    this.showSnackbar = true;
                }

            }
        },
        showDragContext(e) {
            if (!e) this.dragId = null;
        },
        'selection.allSelected': {
            handler(e) {
                this.activeSelectAll = this.selection.allSelected;
            }
        }
    },
    mounted()  {
        // set the current viewMode
        // this.viewMode = localStorage.getItem('ak-data-table-view-mode');

        this.$nextTick(() => {
            let table = this.getTable();

            this.screenResize();
            window.addEventListener('resize', this.screenResize);
        });

        this.resizeObserver = new ResizeObserver(() => {
            this.checkOverflow();
        });

        this.resizeObserver.observe(this.$refs.table);
    },
    beforeDestroy() {
        this.resizeObserver.disconnect();
        window.removeEventListener('resize', this.screenResize);
    }
}, 'grid/ak-data-table-body.html');
